/**
 * Отзывы о призах и рейтинг бренда.
 *
 * То же число, что видит покупатель на карточке бренда: считается одним
 * запросом на сервере. Если бы кабинет считал рейтинг по-своему, «4,8» в
 * приложении и «4,6» здесь однажды разошлись бы, и спорить было бы не о чем.
 *
 * Отзыв может оставить только тот, кто подтвердил получение приза, — поэтому
 * их всегда меньше, чем участников, и это нормально.
 */
import { Card, Empty, Icon, Skeleton, fmtShortDay, num, plural } from '@allswipes/ui';

import { api } from '../api';
import { Layout } from '../components/Layout';
import { useResource } from '../hooks';

export function ReviewsScreen() {
  const data = useResource(() => api.consoleReviews(), []);

  return (
    <Layout title="Отзывы" subtitle="как оценивают выданные призы">
      {data.loading && <Skeleton count={3} height={70} />}

      {data.data && (
        <>
          <div className="stats" style={{ marginBottom: 18 }}>
            <div className="stat">
              <div className="v">{ratingValue(data.data.rating.value)}</div>
              <div className="l">средняя оценка</div>
            </div>
            <div className="stat">
              <div className="v">{num(data.data.rating.count)}</div>
              <div className="l">
                {plural(data.data.rating.count, 'отзыв', 'отзыва', 'отзывов')}
              </div>
            </div>
            {[5, 4, 3, 2, 1].map((star) => (
              <div className="stat" key={star}>
                <div className="v">{num(data.data!.rating.stars[star - 1] ?? 0)}</div>
                <div className="l">{star} ★</div>
              </div>
            ))}
          </div>

          {data.data.reviews.length === 0 ? (
            <Empty icon="star" title="Отзывов пока нет">
              Отзыв можно оставить только после подтверждения получения приза. Как только призы
              начнут выдаваться, оценки появятся здесь.
            </Empty>
          ) : (
            <Card>
              {data.data.reviews.map((review, i) => (
                <div key={i} className="review">
                  <div className="top">
                    <span className="stars">
                      {[1, 2, 3, 4, 5].map((n) => (
                        <Icon key={n} name="star" size={12} className={n <= review.rating ? '' : 'off'} />
                      ))}
                    </span>
                    <span className="who">
                      {review.author} · {review.campaign_name} · {review.prize_label} ·{' '}
                      {fmtShortDay(review.created_at)}
                    </span>
                  </div>
                  {review.text && <div className="txt">{review.text}</div>}
                </div>
              ))}
            </Card>
          )}
        </>
      )}
    </Layout>
  );
}

/** Средняя оценка ×100 как «4,2». */
function ratingValue(value: number): string {
  if (value === 0) return '—';
  const whole = Math.floor(value / 100);
  const frac = Math.round((value % 100) / 10);
  return frac > 0 ? `${whole},${frac}` : String(whole);
}
